<div class="container-fluid">
  <!-- Filters  -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <form [formGroup]="formGroup">
            <div class="row g-2 d-flex align-items-center justify-content-end">
              <div class="col-xs-12 col-lg-3 trend-datepicker">
                <mat-date-range-input
                  [rangePicker]="picker"
                  formGroupName="dateRange"
                >
                  <input
                    matStartDate
                    [placeholder]="'dashboard.crm.startDate' | translate"
                    formControlName="dateStart"
                  />
                  <input
                    matEndDate
                    [placeholder]="'dashboard.crm.endDate' | translate"
                    formControlName="dateEnd"
                  />
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="picker" />
                <mat-date-range-picker #picker>
                  <mat-datepicker-actions>
                    <mat-select
                      class="input-field rounded-lg"
                      [placeholder]="'dashboard.crm.select' | translate"
                      (selectionChange)="onPeriodChange($event)"
                    >
                      <mat-option value="30">
                        {{ "dashboard.crm.last30Days" | translate }}
                      </mat-option>
                      <mat-option value="60">
                        {{ "dashboard.crm.last60Days" | translate }}
                      </mat-option>
                      <mat-option value="120">
                        {{ "dashboard.crm.last120Days" | translate }}
                      </mat-option>
                    </mat-select>
                    <button mat-raised-button matDatepickerApply class="btnOk">
                      OK
                    </button>
                  </mat-datepicker-actions>
                </mat-date-range-picker>
              </div>
              <div
                class="col-xs-6 col-md-6 col-lg-3 mt-2 btn-group trend-button"
              >
                <button
                  type="submit"
                  [matMenuTriggerFor]="funnel"
                  class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle text-truncate mw-100"
                >
                  <span>
                    {{
                      labelFilterFunnel ||
                        ("dashboard.crm.funnelLabel" | translate)
                    }}
                  </span>
                </button>
                <mat-menu #funnel class="custom-menu-panel">
                  <button mat-menu-item (click)="searchByFunnel(null)">
                    {{ "dashboard.crm.all" | translate }}
                  </button>
                  @for (funnel of funnelList; track $index) {
                    <button mat-menu-item (click)="searchByFunnel(funnel)">
                      {{ funnel.name }}
                    </button>
                  }
                </mat-menu>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- KPIs Cards  -->
  <!-- Pipeline no período.
       Title, then the figure the title names, then the money as the supporting line. It used to
       open with a small count, follow with a large amount and only name itself at the bottom —
       so "Total de Oportunidades" sat under R$ 78.450,00 and the reader met two numbers before
       learning what either one was. -->
  <div class="row g-3 mb-3">
    <div class="col-12 col-sm-6 col-xl">
      <div class="card h-100 mb-0">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
            <h5 class="header-title mb-0">{{ "dashboard.crm.totalOpportunities" | translate }}</h5>
            @if (hasChange('totalOpportunities')) {
              <small class="flex-shrink-0" [ngClass]="changeClass('totalOpportunities')"
                [matTooltip]="'dashboard.crm.changeFromPreviousPeriod' | translate" matTooltipPosition="above">
                <i class="mdi" [ngClass]="changeIcon('totalOpportunities')"></i>{{ formatChange('totalOpportunities') }}
              </small>
            }
          </div>
          <h2 class="mb-1 text-nowrap">{{ kpis?.totalOpportunities ?? 0 }}</h2>
          <p class="text-muted mb-0">
            {{ "dashboard.crm.totalOpportunitiesLine" | translate:{ value: (kpis?.totalOpportunitiesValue ?? 0 | currency: "BRL" : "symbol" : "1.2-2") } }}
          </p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl">
      <div class="card h-100 mb-0">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
            <h5 class="header-title mb-0">{{ "dashboard.crm.wonOpportunities" | translate }}</h5>
            @if (hasChange('wonOpportunities')) {
              <small class="flex-shrink-0" [ngClass]="changeClass('wonOpportunities')"
                [matTooltip]="'dashboard.crm.changeFromPreviousPeriod' | translate" matTooltipPosition="above">
                <i class="mdi" [ngClass]="changeIcon('wonOpportunities')"></i>{{ formatChange('wonOpportunities') }}
              </small>
            }
          </div>
          <h2 class="mb-1 text-nowrap text-success">{{ kpis?.wonOpportunities ?? 0 }}</h2>
          <p class="text-muted mb-0">
            {{ "dashboard.crm.wonValueLine" | translate:{ value: (kpis?.wonValue ?? 0 | currency: "BRL" : "symbol" : "1.2-2") } }}
          </p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl">
      <div class="card h-100 mb-0">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
            <h5 class="header-title mb-0">{{ "dashboard.crm.lossOpportunities" | translate }}</h5>
            <!-- More losses is not an improvement: this one is read the other way round. -->
            @if (hasChange('lossOpportunities')) {
              <small class="flex-shrink-0" [ngClass]="changeClass('lossOpportunities', false)"
                [matTooltip]="'dashboard.crm.changeFromPreviousPeriod' | translate" matTooltipPosition="above">
                <i class="mdi" [ngClass]="changeIcon('lossOpportunities')"></i>{{ formatChange('lossOpportunities') }}
              </small>
            }
          </div>
          <h2 class="mb-1 text-nowrap text-danger">{{ kpis?.lossOpportunities ?? 0 }}</h2>
          <p class="text-muted mb-0">
            {{ "dashboard.crm.lostValueLine" | translate:{ value: (kpis?.lossValue ?? 0 | currency: "BRL" : "symbol" : "1.2-2") } }}
          </p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl">
      <div class="card h-100 mb-0">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
            <h5 class="header-title mb-0">{{ "dashboard.crm.conversionRate" | translate }}</h5>
            @if (hasChange('conversionRateQuantity')) {
              <small class="flex-shrink-0" [ngClass]="changeClass('conversionRateQuantity')"
                [matTooltip]="'dashboard.crm.changeFromPreviousPeriod' | translate" matTooltipPosition="above">
                <i class="mdi" [ngClass]="changeIcon('conversionRateQuantity')"></i>{{ formatChange('conversionRateQuantity') }}
              </small>
            }
          </div>
          <h2 class="mb-1 text-nowrap">{{ formatPercentValue((kpis?.conversionRateQuantity ?? 0) * 100) }}</h2>
          <p class="text-muted mb-0">
            {{ "dashboard.crm.conversionLine" | translate:{ value: formatPercentValue((kpis?.conversionRateValue ?? 0) * 100) } }}
          </p>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl">
      <div class="card h-100 mb-0">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
            <h5 class="header-title mb-0">{{ "dashboard.crm.averageTicket" | translate }}</h5>
            @if (hasChange('averageTicket')) {
              <small class="flex-shrink-0" [ngClass]="changeClass('averageTicket')"
                [matTooltip]="'dashboard.crm.changeFromPreviousPeriod' | translate" matTooltipPosition="above">
                <i class="mdi" [ngClass]="changeIcon('averageTicket')"></i>{{ formatChange('averageTicket') }}
              </small>
            }
          </div>
          <h2 class="mb-1 text-nowrap">{{ kpis?.averageTicket ?? 0 | currency: "BRL" : "symbol" : "1.2-2" }}</h2>
          <p class="text-muted mb-0">{{ "dashboard.crm.averageTicketLine" | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- What the CRM still needs filled in. These are not performance readings: they explain WHY
       the money above reads the way it does. A pipeline showing R$ 0,00 of revenue is almost
       never a company that sold nothing — it is one whose won deals were closed with no value
       typed in. The section disappears entirely when every field is filled. -->
  @if (crmDataGaps.length > 0) {
    <h4 class="mt-4 mb-2">{{ "dashboard.crm.dataGapsTitle" | translate }}</h4>
    <div class="row g-3 mb-3">
      @for (gap of crmDataGaps; track gap.key) {
        <div class="col-12 col-sm-6 col-xl">
          <div class="card h-100 mb-0">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                <h5 class="header-title mb-0">{{ gapTitle(gap) }}</h5>
                <span class="badge campaign-badge flex-shrink-0" [ngClass]="gapStatusClass(gap.status)">
                  {{ (gap.status === 'CRITICAL' ? 'dashboard.dashboard.statusCritical' : 'dashboard.dashboard.statusAttention') | translate }}
                </span>
              </div>
              <h3 class="mb-2 text-nowrap" [ngClass]="gapTextClass(gap.status)">{{ gap.value }}</h3>
              <p class="text-muted mb-0">{{ gapText(gap) }}</p>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Graficos -->
  <div class="row gx-2">
    <div class="col-xs-12">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title mb-4">
            {{ "dashboard.crm.opportunitiesPerDay" | translate }}
          </h4>
          <div class="mt-3 chartjs-chart" style="height: 260px">
            @if (revenueChartData) {
              <canvas #chartCanvas></canvas>
            } @else {
              <empty-records-component
                [message]="'dashboard.crm.noDataAvailable' | translate"
                [subMessage]="
                  'dashboard.crm.selectPeriodOrPipeline' | translate
                "
                [icon]="'mdi mdi-alert-circle-outline'"
              />
            }
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-lg-6">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title mb-4">
            {{ "dashboard.crm.revenueByLeadSource" | translate }}
          </h4>
          <div dir="ltr">
            <div class="mt-3 chartjs-chart" style="height: 260px">
              @if (
                revenueByLeadSourceData && revenueByLeadSourceData.length > 0
              ) {
                <canvas #chartRevenueByLeadSource></canvas>
              } @else {
                <empty-records-component
                  [message]="'dashboard.crm.noDataAvailable' | translate"
                  [subMessage]="
                    'dashboard.crm.selectPeriodOrPipeline' | translate
                  "
                  [icon]="'mdi mdi-alert-circle-outline'"
                />
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-lg-6">
      <div class="card" style="height: 358px">
        <div class="card-body">
          <h4 class="header-title mb-1">
            {{ "dashboard.crm.revenueByProducts" | translate }}
          </h4>
          <!-- The measure, named next to the figure (SPEC-2026-10 RF-12): catalogue price × won deals, not deal value. -->
          <p class="text-muted font-12 mb-3">
            {{ "dashboard.crm.productRevenueMeasure" | translate }}
          </p>
          @if (productsPercentage && productsPercentage.length > 0) {
            <div dir="ltr">
              @for (product of productsPercentage; track $index) {
                <span
                  class="d-flex align-items-center justify-content-between font-14 mb-1 fw-semibold d-block"
                >
                  {{ product?.name }}
                  <small class="font-8 fw-bold">
                    {{ product.percentage | number: "1.2-2" }}%
                  </small>
                </span>
                <div class="progress mb-3 progress-sm">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    [style.width.%]="product.percentage"
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
              }
            </div>
          } @else {
            <empty-records-component
              [message]="'dashboard.crm.noDataAvailable' | translate"
              [subMessage]="'dashboard.crm.selectPeriodOrPipeline' | translate"
              [icon]="'mdi mdi-alert-circle-outline'"
            />
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Tables  -->
  <div class="row g-2">
    <!-- How much of the pipeline sits with each person. The bar makes the concentration visible
         at a glance; the diagnostic card above states it in words. -->
    <div class="col-xs-12 col-lg-6">
      <div class="card h-100">
        <div class="card-body">
          <h4 class="header-title mb-1">{{ "dashboard.crm.pipelineByAttendantTitle" | translate }}</h4>
          <p class="text-muted mb-3">{{ "dashboard.crm.pipelineByAttendantSubtitle" | translate }}</p>
          @if (pipelineByAttendant.length > 0) {
            @for (row of pipelineByAttendant; track row.name) {
              <div class="mb-3">
                <div class="d-flex justify-content-between align-items-baseline gap-2 mb-1">
                  <span class="fw-bold text-truncate">{{ row.name }}</span>
                  <small class="text-muted text-nowrap">{{ row.value | currency: "BRL" : "symbol" : "1.2-2" }}</small>
                </div>
                <div class="progress" role="progressbar" [attr.aria-label]="row.name">
                  <div class="progress-bar bg-info" [style.width.%]="row.share"></div>
                </div>
              </div>
            }
          } @else {
            <p class="text-muted mb-0">{{ "dashboard.crm.noDataForPeriod" | translate }}</p>
          }
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-lg-6">
      <div class="card h-39">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="header-title">
            {{ "dashboard.crm.topAttendants" | translate }}
          </h4>
        </div>

        <div class="card-body pt-0">
          <div class="table-responsive">
            <table class="table table-sm table-hover table-centered mb-0">
              <thead>
                <tr>
                  <th class="text-primary-emphasis">
                    {{ "dashboard.crm.attendant" | translate }}
                  </th>
                  <th class="text-primary-emphasis text-center">
                    {{ "dashboard.crm.opportunities" | translate }}
                  </th>
                  <th class="text-primary-emphasis text-center">
                    {{ "dashboard.crm.won" | translate }}
                  </th>
                  <th class="text-primary-emphasis text-center">
                    {{ "dashboard.crm.lost" | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                @for (user of users; track $index) {
                  <tr>
                    <td>
                      <span
                        class="font-14 mb-1 fw-semibold text-truncate d-block"
                        [matTooltip]="(user?.['userName'] ?? '') + ''"
                      >
                        {{
                          $any($safeNavigationMigration(user?.["userName"]))?.length > 12
                            ? ($any($safeNavigationMigration(user?.["userName"])) | slice: 0 : 12) + "..."
                            : user?.["userName"]
                        }}
                      </span>
                    </td>
                    <td>
                      <div class="d-flex flex-column text-center">
                        <span>
                          {{ user?.["totalOpportunities"] ?? 0 }}
                        </span>
                        <small>
                          {{
                            converteCurrency(
                              +(user?.["totalOpportunitiesValue"] ?? 0)
                            )
                          }}
                        </small>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex flex-column text-center">
                        <span>
                          {{ user?.["wonOpportunities"] ?? 0 }}
                        </span>
                        <small>
                          {{ converteCurrency(+(user?.["wonValue"] ?? 0)) }}
                        </small>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex flex-column text-center">
                        <span>
                          {{ user?.["lossOpportunities"] ?? 0 }}
                        </span>
                        <small>
                          {{ converteCurrency(+(user?.["lossValue"] ?? 0)) }}
                        </small>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-lg-6">
      <div class="card h-39">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="header-title">
            {{ "dashboard.crm.topCustomers" | translate }}
          </h4>
        </div>

        <div class="card-body pt-2">
          @for (customer of customers; track $index) {
            <div class="d-flex align-items-start mb-2">
              <!-- <img
                class="me-3 rounded-circle"
                width="40"
                [alt]="'dashboard.crm.placeholderImage' | translate"
              /> -->
              <div class="w-100 overflow-hidden">
                <span class="badge badge-verse float-end">
                  +
                  {{
                    $safeNavigationMigration(customer?.["wonValue"])
                      | currency: "BRL" : "symbol" : "1.2-2"
                  }}
                </span>
                <h5 class="mt-0 mb-1 text-truncate">
                  {{ customer?.["customerName"] }}
                </h5>
                <span class="font-13">
                  {{ customer?.["wonOpportunities"] ?? 0 }}
                  {{
                    (customer?.["wonOpportunities"] == 1
                      ? "dashboard.crm.opportunitySingular"
                      : "dashboard.crm.opportunityPlural"
                    ) | translate
                  }}
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-lg-6">
      <div class="card h-39">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="header-title">
            {{ "dashboard.crm.topProducts" | translate }}
          </h4>
        </div>

        <div class="card-body pt-2">
          @for (product of products; track $index) {
            <div class="d-flex align-items-start mb-2">
              <!-- <img
                class="me-3 rounded-circle"
                width="40"
                [alt]="'dashboard.crm.placeholderImage' | translate"
              /> -->
              <div class="w-100 overflow-hidden">
                <span class="badge badge-verse float-end">
                  +
                  {{
                    $safeNavigationMigration(product?.["soldValue"])
                      | currency: "BRL" : "symbol" : "1.2-2"
                  }}
                </span>
                <h5 class="mt-0 mb-1 text-truncate">
                  {{ product?.["productName"] }}
                </h5>
                <span class="font-13">
                  {{ product?.["soldCount"] ?? 0 }}
                  {{
                    (product?.["soldCount"] == 1
                      ? "dashboard.crm.saleSingular"
                      : "dashboard.crm.salePlural"
                    ) | translate
                  }}
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
